import type { SocialLink } from '@kkf/design'

export interface TeamMemberDetail {
  image: string
  name: string
  role: string
  descr: string
  infos: { icon: string; label: string; href: string }[]
  socials: SocialLink[]
  experiences: { title: string; value: number }[]
}

/** Content for the team-details page. */
export const TEAM_MEMBER_DETAIL: TeamMemberDetail = {
  image: '/assets/img/team-details-img.jpg',
  name: 'Danial Frankie',
  role: 'Co-Founder',
  descr:
    'Adipiscing elit. Mauris viverra nisl quis mollis laoreet. Ut eget lacus a felis accumsan pharetra in dignissim enim. In amet odio mollis urna aliquet volutpat. Sed bibendum nisl vehicula imperdiet imperdiet, augue massa fringilla.',
  infos: [
    { icon: 'telephone-call', label: '+208-555-0112', href: 'tel:2085550112' },
    { icon: 'email', label: 'thomas.tatum@example.com', href: 'mailto:thomas.tatum@example.com' },
  ],
  socials: [
    { icon: 'facebook', href: '#', label: 'Facebook' },
    { icon: 'instagram', href: '#', label: 'Instagram' },
    { icon: 'linkedin-big-logo', href: '#', label: 'LinkedIn' },
    { icon: 'twitter-1', href: '#', label: 'Twitter' },
  ],
  experiences: [
    { title: 'Productivity', value: 90 },
    { title: 'Digital Marketing', value: 87 },
    { title: 'Technology', value: 65 },
  ],
}
